import { render, staticRenderFns } from "./FormCategoria.vue?vue&type=template&id=f5b679ac"
import script from "./FormCategoria.vue?vue&type=script&lang=js"
export * from "./FormCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports